import { render, staticRenderFns } from "./BoolFilterChips.vue?vue&type=template&id=15f84dfd&scoped=true&"
import script from "./BoolFilterChips.vue?vue&type=script&lang=js&"
export * from "./BoolFilterChips.vue?vue&type=script&lang=js&"
import style0 from "./BoolFilterChips.vue?vue&type=style&index=0&id=15f84dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f84dfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VChip,VIcon,VProgressCircular})
